import { useEffect, useState } from 'react';
import { getPayPalWindow } from '../../../utils/paypal';
import type { PayPalSdkStatus } from '../../interfaces';

export const usePayPalSdk = (clientId?: string, currency = 'USD') => {
  const [status, setStatus] = useState<PayPalSdkStatus>(
    clientId ? 'loading' : 'idle'
  );

  useEffect(() => {
    if (!clientId) {
      setStatus('idle');
      return;
    }

    const paypalWindow = getPayPalWindow();
    if (paypalWindow.paypal) {
      setStatus('ready');
      return;
    }

    setStatus('loading');

    const existingScript = document.querySelector<HTMLScriptElement>(
      'script[data-paypal-sdk="true"]'
    );

    if (existingScript) {
      const handleLoad = () => setStatus('ready');
      const handleError = () => setStatus('error');
      existingScript.addEventListener('load', handleLoad);
      existingScript.addEventListener('error', handleError);

      return () => {
        existingScript.removeEventListener('load', handleLoad);
        existingScript.removeEventListener('error', handleError);
      };
    }

    const script = document.createElement('script');
    script.src = `https://www.paypal.com/sdk/js?client-id=${encodeURIComponent(
      clientId
    )}&currency=${encodeURIComponent(currency)}&intent=capture`;
    script.async = true;
    script.dataset.paypalSdk = 'true';
    script.onload = () => setStatus('ready');
    script.onerror = () => setStatus('error');
    document.body.appendChild(script);

    return () => {
      script.onload = null;
      script.onerror = null;
    };
  }, [clientId, currency]);

  return status;
};
